export enum DocumentStatusEnum {
    UnderReview = 0,
    Rejected = 1,
    Approved = 2
}
